// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file place/v1/place.proto (package place.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file place/v1/place.proto.
 */
export const file_place_v1_place: GenFile = /*@__PURE__*/
  fileDesc("ChRwbGFjZS92MS9wbGFjZS5wcm90bxIIcGxhY2UudjEiWQoNU2VhcmNoUmVxdWVzdBINCgVxdWVyeRgBIAEoCRItCgdmaWx0ZXJzGAIgASgLMhcucGxhY2UudjEuU2VhcmNoRmlsdGVyc0gAiAEBQgoKCF9maWx0ZXJzIjMKDVNlYXJjaEZpbHRlcnMSIgoFdHlwZXMYASADKA4yEy5wbGFjZS52MS5QbGFjZVR5cGUiNwoOU2VhcmNoUmVzcG9uc2USJQoGcGxhY2VzGAEgAygLMhUucGxhY2UudjEuU2NvcmVkUGxhY2UiagoLTmVhclJlcXVlc3QSEgoKZGFwX251bWJlchgBIAEoCRIQCghsYXRpdHVkZRgCIAEoARIRCglsb25naXR1ZGUYAyABKAESIgoFdHlwZXMYBCADKA4yEy5wbGFjZS52MS5QbGFjZVR5cGUiNQoMTmVhclJlc3BvbnNlEiUKBnBsYWNlcxgBIAMoCzIVLnBsYWNlLnYxLlNjb3JlZFBsYWNlIjwKC1Njb3JlZFBsYWNlEg0KBXNjb3JlGAEgASgCEh4KBXBsYWNlGAIgASgLMg8ucGxhY2UudjEuUGxhY2UixgIKBVBsYWNlEgoKAmlkGAEgASgJEjoKEXRyYW5zcG9ydGF0aW9uX2lkGAIgASgLMhoucGxhY2UudjEuVHJhbnNwb3J0YXRpb25JREgAiAEBEgwKBG5hbWUYAyABKAkSIQoEdHlwZRgEIAEoDjITLnBsYWNlLnYxLlBsYWNlVHlwZRInCgdhZGRyZXNzGAUgASgLMhEucGxhY2UudjEuQWRkcmVzc0gBiAEBEhAKCGxhdGl0dWRlGAYgASgBEhEKCWxvbmdpdHVkZRgHIAEoARIQCgh6aXBfY29kZRgIIAEoCRIiCgdjb3VudHJ5GAkgASgLMhEucGxhY2UudjEuQ291bnRyeRIMCgRjaXR5GAogASgJEhAKCHRpbWV6b25lGAsgASgJQhQKEl90cmFuc3BvcnRhdGlvbl9pZEIKCghfYWRkcmVzcyJyCgdBZGRyZXNzEgoKAmlkGAEgASgJEhUKDXN0cmVldF9udW1iZXIYAiABKAkSEwoLc3RyZWV0X25hbWUYAyABKAkSEAoIemlwX2NvZGUYBCABKAkSDAoEY2l0eRgFIAEoCRIPCgdjb3VudHJ5GAcgASgJIiUKB0NvdW50cnkSDAoEY29kZRgBIAEoCRIMCgRuYW1lGAIgASgJIjwKEFRyYW5zcG9ydGF0aW9uSUQSDQoDdWljGAEgASgJSAASDgoEaWF0YRgCIAEoCUgAQgkKB3R5cGVfaWQqjQEKCVBsYWNlVHlwZRIaChZQTEFDRV9UWVBFX1VOU1BFQ0lGSUVEEAASEwoPUExBQ0VfVFlQRV9DSVRZEAESHAoYUExBQ0VfVFlQRV9UUkFJTl9TVEFUSU9OEAISFgoSUExBQ0VfVFlQRV9BSVJQT1JUEAMSGQoVUExBQ0VfVFlQRV9DQVJfUkVOVEVSEAQyhgEKDFBsYWNlU2VydmljZRI9CgZTZWFyY2gSFy5wbGFjZS52MS5TZWFyY2hSZXF1ZXN0GhgucGxhY2UudjEuU2VhcmNoUmVzcG9uc2UiABI3CgROZWFyEhUucGxhY2UudjEuTmVhclJlcXVlc3QaFi5wbGFjZS52MS5OZWFyUmVzcG9uc2UiAGIGcHJvdG8z");

/**
 * @generated from message place.v1.SearchRequest
 */
export type SearchRequest = Message<"place.v1.SearchRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: optional place.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters;
};

/**
 * Describes the message place.v1.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 0);

/**
 * @generated from message place.v1.SearchFilters
 */
export type SearchFilters = Message<"place.v1.SearchFilters"> & {
  /**
   * @generated from field: repeated place.v1.PlaceType types = 1;
   */
  types: PlaceType[];
};

/**
 * Describes the message place.v1.SearchFilters.
 * Use `create(SearchFiltersSchema)` to create a new message.
 */
export const SearchFiltersSchema: GenMessage<SearchFilters> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 1);

/**
 * @generated from message place.v1.SearchResponse
 */
export type SearchResponse = Message<"place.v1.SearchResponse"> & {
  /**
   * @generated from field: repeated place.v1.ScoredPlace places = 1;
   */
  places: ScoredPlace[];
};

/**
 * Describes the message place.v1.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 2);

/**
 * @generated from message place.v1.NearRequest
 */
export type NearRequest = Message<"place.v1.NearRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;

  /**
   * @generated from field: double latitude = 2;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 3;
   */
  longitude: number;

  /**
   * @generated from field: repeated place.v1.PlaceType types = 4;
   */
  types: PlaceType[];
};

/**
 * Describes the message place.v1.NearRequest.
 * Use `create(NearRequestSchema)` to create a new message.
 */
export const NearRequestSchema: GenMessage<NearRequest> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 3);

/**
 * @generated from message place.v1.NearResponse
 */
export type NearResponse = Message<"place.v1.NearResponse"> & {
  /**
   * @generated from field: repeated place.v1.ScoredPlace places = 1;
   */
  places: ScoredPlace[];
};

/**
 * Describes the message place.v1.NearResponse.
 * Use `create(NearResponseSchema)` to create a new message.
 */
export const NearResponseSchema: GenMessage<NearResponse> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 4);

/**
 * @generated from message place.v1.ScoredPlace
 */
export type ScoredPlace = Message<"place.v1.ScoredPlace"> & {
  /**
   * @generated from field: float score = 1;
   */
  score: number;

  /**
   * @generated from field: place.v1.Place place = 2;
   */
  place?: Place;
};

/**
 * Describes the message place.v1.ScoredPlace.
 * Use `create(ScoredPlaceSchema)` to create a new message.
 */
export const ScoredPlaceSchema: GenMessage<ScoredPlace> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 5);

/**
 * @generated from message place.v1.Place
 */
export type Place = Message<"place.v1.Place"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional place.v1.TransportationID transportation_id = 2;
   */
  transportationId?: TransportationID;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: place.v1.PlaceType type = 4;
   */
  type: PlaceType;

  /**
   * @generated from field: optional place.v1.Address address = 5;
   */
  address?: Address;

  /**
   * @generated from field: double latitude = 6;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 7;
   */
  longitude: number;

  /**
   * @generated from field: string zip_code = 8;
   */
  zipCode: string;

  /**
   * @generated from field: place.v1.Country country = 9;
   */
  country?: Country;

  /**
   * @generated from field: string city = 10;
   */
  city: string;

  /**
   * @generated from field: string timezone = 11;
   */
  timezone: string;
};

/**
 * Describes the message place.v1.Place.
 * Use `create(PlaceSchema)` to create a new message.
 */
export const PlaceSchema: GenMessage<Place> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 6);

/**
 * @generated from message place.v1.Address
 */
export type Address = Message<"place.v1.Address"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string street_number = 2;
   */
  streetNumber: string;

  /**
   * @generated from field: string street_name = 3;
   */
  streetName: string;

  /**
   * @generated from field: string zip_code = 4;
   */
  zipCode: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string country = 7;
   */
  country: string;
};

/**
 * Describes the message place.v1.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema: GenMessage<Address> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 7);

/**
 * @generated from message place.v1.Country
 */
export type Country = Message<"place.v1.Country"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message place.v1.Country.
 * Use `create(CountrySchema)` to create a new message.
 */
export const CountrySchema: GenMessage<Country> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 8);

/**
 * @generated from message place.v1.TransportationID
 */
export type TransportationID = Message<"place.v1.TransportationID"> & {
  /**
   * @generated from oneof place.v1.TransportationID.type_id
   */
  typeId: {
    /**
     * @generated from field: string uic = 1;
     */
    value: string;
    case: "uic";
  } | {
    /**
     * @generated from field: string iata = 2;
     */
    value: string;
    case: "iata";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message place.v1.TransportationID.
 * Use `create(TransportationIDSchema)` to create a new message.
 */
export const TransportationIDSchema: GenMessage<TransportationID> = /*@__PURE__*/
  messageDesc(file_place_v1_place, 9);

/**
 * @generated from enum place.v1.PlaceType
 */
export enum PlaceType {
  /**
   * @generated from enum value: PLACE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACE_TYPE_CITY = 1;
   */
  CITY = 1,

  /**
   * @generated from enum value: PLACE_TYPE_TRAIN_STATION = 2;
   */
  TRAIN_STATION = 2,

  /**
   * @generated from enum value: PLACE_TYPE_AIRPORT = 3;
   */
  AIRPORT = 3,

  /**
   * @generated from enum value: PLACE_TYPE_CAR_RENTER = 4;
   */
  CAR_RENTER = 4,
}

/**
 * Describes the enum place.v1.PlaceType.
 */
export const PlaceTypeSchema: GenEnum<PlaceType> = /*@__PURE__*/
  enumDesc(file_place_v1_place, 0);

/**
 * @generated from service place.v1.PlaceService
 */
export const PlaceService: GenService<{
  /**
   * @generated from rpc place.v1.PlaceService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
  /**
   * @generated from rpc place.v1.PlaceService.Near
   */
  near: {
    methodKind: "unary";
    input: typeof NearRequestSchema;
    output: typeof NearResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_place_v1_place, 0);

